module.exports = __webpack_public_path__ + "img/1nKN014l4b8s79RLsrPqL7.c7abcd1b.svg";